import React from 'react';
import { CheckCircle, Target, Award, Users } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const companyInfo = {
  administrator: "Mary Ngugi"
};

const About = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-slate-700 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">About USKE SUPPLY LLC</h1>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Your Trusted Partner for Quality General Supplies Since Day One
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        {/* Our Story */}
        <div className="max-w-4xl mx-auto mb-16">
          <h2 className="text-3xl font-bold text-slate-800 mb-6 text-center">Our Story</h2>
          <div className="bg-white p-8 rounded-lg shadow-md border-2">
            <p className="text-slate-700 leading-relaxed mb-4">
              Established in 2024, USKE SUPPLY LLC is a premier supplier of high-quality general supplies, serving businesses across
              Washington and beyond. Founded with a vision to simplify procurement for businesses of all sizes,
              we have become a trusted name in the industry.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4">
              Under the leadership of <strong>{companyInfo.administrator}</strong>, our company has grown from
              a local supplier to a comprehensive solution provider for offices, facilities, and organizations
              seeking reliable, quality products.
            </p>
            <p className="text-slate-700 leading-relaxed">
              We believe in building lasting relationships with our clients by delivering exceptional products,
              competitive pricing, and outstanding customer service. Our extensive catalog includes everything
              from office supplies and furniture to technology accessories and cleaning products.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-slate-800 mb-8 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="border-2 hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="font-semibold text-lg mb-2 text-slate-800">Quality</h3>
                <p className="text-slate-600">We source only the best products from trusted brands</p>
              </CardContent>
            </Card>
            <Card className="border-2 hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Target className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="font-semibold text-lg mb-2 text-slate-800">Reliability</h3>
                <p className="text-slate-600">Consistent delivery and service you can count on</p>
              </CardContent>
            </Card>
            <Card className="border-2 hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="h-8 w-8 text-purple-600" />
                </div>
                <h3 className="font-semibold text-lg mb-2 text-slate-800">Excellence</h3>
                <p className="text-slate-600">Committed to exceeding customer expectations</p>
              </CardContent>
            </Card>
            <Card className="border-2 hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="h-8 w-8 text-orange-600" />
                </div>
                <h3 className="font-semibold text-lg mb-2 text-slate-800">Partnership</h3>
                <p className="text-slate-600">Building long-term relationships with our clients</p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* What We Offer */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-slate-800 mb-8 text-center">What We Offer</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            <Card className="border-2">
              <CardContent className="p-6">
                <h3 className="font-semibold text-lg mb-3 text-slate-800">Comprehensive Product Range</h3>
                <ul className="space-y-2 text-slate-600">
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    Office Supplies
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    Paper Products
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    Office Furniture
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    Technology & Accessories
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    Ink & Toner
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    Groceries & Break Room Supplies
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    Cleaning Products
                  </li>
                </ul>
              </CardContent>
            </Card>
            <Card className="border-2">
              <CardContent className="p-6">
                <h3 className="font-semibold text-lg mb-3 text-slate-800">Our Services</h3>
                <ul className="space-y-2 text-slate-600">
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-blue-600" />
                    Fast & Reliable Delivery
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-blue-600" />
                    Bulk Order Discounts
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-blue-600" />
                    Account Management
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-blue-600" />
                    Custom Quotes
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-blue-600" />
                    Easy Returns & Exchanges
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-blue-600" />
                    Dedicated Support Team
                  </li>
                  <li className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-blue-600" />
                    Online Order Tracking
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-r from-blue-600 to-slate-700 text-white rounded-lg p-12 text-center">
          <h2 className="text-3xl font-bold mb-4">Partner With Us Today</h2>
          <p className="text-xl mb-8 opacity-90">
            Experience the difference of working with a dedicated supply partner
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href="/products" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-slate-100 transition-colors">
              Browse Products
            </a>
            <a href="/contact" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;